import React, { useState } from 'react';
import { Modal, Card, Input, Button, Select, Row, Col } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const { Option } = Select;

const AddOptionModal = ({ 
  visible, 
  onCancel, 
  onAddOption, 
  assetDisplayProperties 
}) => {
  const [newOptionText, setNewOptionText] = useState('');

  const handleCancel = () => {
    setNewOptionText('');
    onCancel();
  };

  const handleAddTextOption = () => {
    if (!newOptionText.trim()) return;
    
    onAddOption('text', newOptionText.trim());
    setNewOptionText('');
  };

  const handleAddVariableOption = (variable) => {
    if (!variable) return;
    
    onAddOption('variable', variable);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && newOptionText.trim()) {
      handleAddTextOption();
    }
  };

  return (
    <Modal
      title="Adicionar Nova Opção"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      centered
      width={500}
    >
      <div style={{ padding: '20px 0' }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Card style={{ marginBottom: '8px' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <PlusOutlined style={{ fontSize: '20px', color: '#1890ff', marginRight: '8px' }} />
                  <span style={{ fontWeight: 'bold' }}>Nova Opção Personalizada</span>
                </div>
                <div style={{ color: '#666', fontSize: '12px', marginBottom: '12px' }}>
                  Digite o texto da nova opção
                </div>
                <Input
                  placeholder="Digite o texto da opção"
                  value={newOptionText}
                  onChange={(e) => setNewOptionText(e.target.value)}
                  onPressEnter={handleKeyPress}
                  style={{ marginBottom: '12px' }}
                />
                <Button 
                  type="primary" 
                  onClick={handleAddTextOption}
                  disabled={!newOptionText.trim()}
                  style={{ width: '100%' }}
                >
                  Adicionar Opção
                </Button>
              </div>
            </Card>
          </Col>
          
          <Col span={24}>
            <div style={{ 
              textAlign: 'center', 
              margin: '8px 0',
              color: '#999',
              fontSize: '14px',
              fontWeight: '500'
            }}>
              ou
            </div>
          </Col>
          
          <Col span={24}>
            <Card>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
                  <span style={{ fontSize: '20px', marginRight: '8px' }}>🔗</span>
                  <span style={{ fontWeight: 'bold' }}>Variável do Asset</span>
                </div>
                <div style={{ color: '#666', fontSize: '12px', marginBottom: '12px' }}>
                  Usar uma propriedade do asset como valor dinâmico
                </div>
                <Select
                  placeholder="Selecione uma propriedade"
                  style={{ width: '100%' }}
                  onChange={handleAddVariableOption}
                >
                  {assetDisplayProperties.map((prop) => (
                    <Option key={prop.key} value={prop.key}>
                      {prop.label}
                    </Option>
                  ))}
                </Select>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default AddOptionModal;